import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames/bind'

import { BUTTON_OFF, BUTTON_ON } from '../../constants'
import { pushDataLayerSimple } from 'js/helpers/gtm'

import styles from './IconField.module.scss'

const cx = classnames.bind(styles)

const IconField = function (props) {
  const {
    className,
    onChange,
    value = BUTTON_OFF,
    data,
    data: {
      icon,
      text,
    }
  } = props;
  const isActive = value === BUTTON_ON

  const onButtonClick = function () {
    onChange(value === BUTTON_ON ? BUTTON_OFF : BUTTON_ON, data)
  }

  return (
    <div className={cx('root', className)}>
      <button
        type="button"
        className={cx('field', {active: isActive})}
        onClick={onButtonClick}
      >
        {icon && (<i className={cx('pic', `icon-${icon}`)}/>)}
        <span className={cx('text')}>{text}</span>
      </button>
    </div>
  )
}


IconField.propTypes = {
  data: PropTypes.shape({
    icon: PropTypes.string,
    text: PropTypes.string
  }).isRequired,
  value: PropTypes.oneOf([BUTTON_ON, BUTTON_OFF]),
  onChange: PropTypes.func.isRequired,
}

export default IconField
